enum Operator {
  EQ = "equal",
  NEQ = "not_equal",
  EQ_SUP = "equal_or_superior",
  EQ_INF = "equal_or_inferior",
  SUP = "superior",
  INF = "inferior",
  PAT = "pattern",
  ISNOTPAT = "isNotPattern",
}

const isNotPattern = (current: String = "", valueToCompare: String = "") => {
  if (!current || current == null) {
    return false;
  } else {
    if (Array.isArray(current)) {
      const currentWord = current.join("||").toLowerCase();
      const patternWord = valueToCompare.toLowerCase();
      const result = !currentWord.includes(patternWord);

      return result;
    }
    const currentWord = current.toLowerCase();
    const patternWord = valueToCompare.toLowerCase();
    const result = !currentWord.includes(patternWord);

    return result;
  }
};
const isPattern = (current: String = "", valueToCompare: String = "") => {
  if (!current || current == null) {
    return false;
  } else {
    if (Array.isArray(current)) {
      const currentWord = current.join("||").toLowerCase();
      const patternWord = valueToCompare.toLowerCase();
      const result = currentWord.includes(patternWord);
      return result;
    }
    const currentWord = current.toLowerCase();
    const patternWord = valueToCompare.toLowerCase();
    const result = currentWord.includes(patternWord);
    return result;
  }
};
const getTableRowValue = (tableValue: any, row: string) => {
  let parsed = tableValue;
  if (typeof tableValue === "string") {
    try {
      parsed = JSON.parse(tableValue);
    } catch (error) {
      return undefined;
    }
  }
  return parsed && typeof parsed === "object" ? parsed[row] : undefined;
};

function evaluate(c: any, values: any[]): boolean {
  const { fieldToCompare, ifCondition, value } = c;
  const myArray = fieldToCompare.split("||");
  const entires = Object.keys(values).map(function (key) {
    return { key: key, value: values[key] };
  });

  const answer = entires.find(
    (element) => element.key === c.fieldToCompare || element.key === myArray[0],
  );

  if (!answer || !answer.value) return false;

  // "field||row" targets one row of a TableField, whose value is an object
  // of { [row]: answer } while editing but a JSON string once persisted.
  // Every operator must compare that row's answer: previously only EQUAL
  // looked at the row (and only on the object form), so e.g. "row != No"
  // compared the whole table and was always true.
  const current = myArray[1]
    ? getTableRowValue(answer.value, myArray[1])
    : answer.value;

  if (!current) return false;

  switch (ifCondition) {
    case Operator.EQ:
      return current === value;
    case Operator.NEQ:
      return current !== value;
    case Operator.EQ_SUP:
      return Number(current) >= Number(value);
    case Operator.EQ_INF:
      return Number(current) <= Number(value);
    case Operator.SUP:
      return Number(current) > Number(value);
    case Operator.INF:
      return Number(current) < Number(value);
    case Operator.PAT:
      return isPattern(current, value);
    case Operator.ISNOTPAT:
      return isNotPattern(current, value);
    default:
      return false;
  }
}
export const resolver = (conditionalStatment: any, values) => {
  const { status, conditions, operator, action } = conditionalStatment;
  let shouldShow = true;
  let temp: boolean[] = [];

  if (status && action !== "E" && action !== "D") {
    conditions.map((c) => {
      temp.push(evaluate(c, values));
    });
    if (operator === "all") {
      temp.map((t) => {
        if (t == false) {
          shouldShow = false;
        }
      });
    } else if (operator === "one") {
      let b = false;

      temp.map((t) => {
        if (t == true) {
          b = true;
        }
      });
      b ? (shouldShow = true) : (shouldShow = false);
    }
  }

  switch (action) {
    case "S":
      return shouldShow;
    case "H":
      return !shouldShow;
    default:
      return shouldShow;
  }
};
export const resolverDisablingField = (
  conditionalStatment: any,
  values: any[],
) => {
  const { status, conditions, operator, action } = conditionalStatment;
  let shouldShow = true;
  let temp: boolean[] = [];

  if (status && action !== "S" && action !== "H") {
    conditions.map((c: any) => {
      temp.push(evaluate(c, values));
    });
    if (operator === "all") {
      temp.map((t) => {
        if (t == false) {
          shouldShow = false;
        }
      });
    } else if (operator === "one") {
      let b = false;

      temp.map((t) => {
        if (t == true) {
          b = true;
        }
      });
      b ? (shouldShow = true) : (shouldShow = false);
    }
  }

  switch (action) {
    case "D":
      return shouldShow;
    case "E":
      return !shouldShow;

    default:
      return !shouldShow;
  }
};
export const filterInputs = (elements: any[], elId: string) => {
  let filterdInputs: any[] = [];
  elements.map((e) => {
    if (
      e.id !== elId &&
      !e.content &&
      e.type !== "Image" &&
      e.type !== "Photo" &&
      e.type !== "ident" &&
      e.type !== "fullAdress" &&
      e.type !== "Signature" &&
      e.type !== "captcha"
    ) {
      if (e.type === "TableField") {
        e.lignes.map((l) => {
          let obj = new Object();
          obj["label"] = "grille_" + l.label;
          obj["field_name"] = `${e.field_name}||${l.label}`;
          filterdInputs.push(obj);
        });
      } else filterdInputs.push(e);
    }
  });
  return filterdInputs;
};
export const filterInputsForPage = (elements: any[]) => {
  let filterdInputs: any[] = [];
  elements.map((e) => {
    if (
      !e.content &&
      e.type !== "Image" &&
      e.type !== "Photo" &&
      e.type !== "ident" &&
      e.type !== "fullAdress" &&
      e.type !== "Signature" &&
      e.type !== "captcha"
    ) {
      if (e.type === "TableField") {
        e.lignes.map((l) => {
          let obj = new Object();
          obj["label"] = "grille_" + l.label;
          obj["field_name"] = `${e.field_name}||${l.label}`;

          filterdInputs.push(obj);
        });
      } else filterdInputs.push(e);
    }
  });

  return filterdInputs;
};
